export const dataFields = {
  CNES: {
    field: 'nu_cnes',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  CPF: {
    field: 'nu_cpf',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  CNS: {
    field: 'nu_cns',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  CBO: 'co_cbo',
  Função: 'no_cbo',
  Profissional: 'no_profissional',
  Divergência: 'divergencias',
}
